'use strict';

var cart = require('../cart/cart');

var updateMiniCart = true;
var minicartTimeout = null;

module.exports = function () {
    cart();

    $('.minicart').on('count:update', function (event, count) {
        if (count && $.isNumeric(count.quantityTotal)) {
            if (count.quantityTotal > 0) {
                $('.minicart .minicart-quantity').addClass('active');
            } else {
                $('.minicart .minicart-quantity').removeClass('active');
            }
            $('.minicart .minicart-quantity').text(count.quantityTotal);
            $('.minicart .minicart-link').attr({
                'aria-label':
                    count.quantityTotal == 1
                        ? count.minicartCountOfItem
                        : count.minicartCountOfItems,
                title:
                    count.quantityTotal == 1
                        ? count.minicartCountOfItem
                        : count.minicartCountOfItems,
            });
        }
    });

    $('.minicart').on('mouseenter focusin touchstart', function () {
        if (minicartTimeout) {
            clearTimeout(minicartTimeout);
        }

        var url = $('.minicart').data('action-url');
        var count = parseInt($('.minicart .minicart-quantity').text(), 10);

        if (count > 0 && $('.minicart .popover.show').length === 0) {
            if (!updateMiniCart) {
                $('.minicart .popover').addClass('show');
                return;
            }

            $('.minicart .popover').addClass('show');
            $('.minicart .popover').spinner().start();
            $.get(url, function (data) {
                $('.minicart .popover').empty();
                $('.minicart .popover').append(data);
                updateMiniCart = false;
                $.spinner().stop();
            });
        }
    });

    $('body').on('touchstart click', function (e) {
        if ($('.minicart').has(e.target).length <= 0) {
            $('.minicart .popover').removeClass('show');
        }
    });

    $('.minicart').on('mouseleave focusout', function (event) {
        if (
            (event.type === 'focusout' &&
                $('.minicart').has(event.target).length > 0) ||
            (event.type === 'mouseleave' &&
                $(event.target).is('.minicart .quantity')) ||
            $('body').hasClass('modal-open')
        ) {
            event.stopPropagation();

            return;
        }

        var timeout = 2000;

        if (
            $('.minicart-timeout').val() !== undefined &&
            $('.minicart-timeout').val() !== null &&
            $('.minicart-timeout').val() !== ''
        ) {
            timeout = parseInt($('.minicart-timeout').val(), 10);
        }

        minicartTimeout = setTimeout(function () {
            $('.minicart .popover').removeClass('show');
        }, timeout);
    });

    $('body').on('change', '.minicart .quantity', function () {
        if (
            $(this).parents('.bonus-product-line-item').length &&
            $('.cart-page').length
        ) {
            location.reload();
        }
    });
    $('body').on('product:afterAddToCart', function () {
        updateMiniCart = true;
    });
    $('body').on('cart:update', function () {
        updateMiniCart = true;
        var minicartCount = parseInt(
            $('.minicart .minicart-quantity').text(),
            10
        );
        if (minicartCount > 0) {
            $('.minicart .minicart-quantity').addClass('active');
        } else {
            $('.minicart .minicart-quantity').removeClass('active');
        }
    });
};
